// Yard layouts for Coolamon Bay. The JSON is generated by
// scripts/layouts/generate.mjs — edit the script and re-run it, not the JSON.
import type { Layout } from '../types';
import kerbsideBackyard from './kerbside-backyard.json';
import kerbsideFront from './kerbside-front.json';
import grevilleaAveWeatherboard from './grevillea-ave-weatherboard.json';
import ridgeRdQuarterAcre from './ridge-rd-quarter-acre.json';
import bayRdBeachShack from './bay-rd-beach-shack.json';
import federationDriveStrips from './federation-drive-strips.json';
import gumtreeHeightsFootyOval from './gumtree-heights-footy-oval.json';
import coolamonBayCricketOval from './coolamon-bay-cricket-oval.json';
import kerbsidePrimarySchoolOval from './kerbside-primary-school-oval.json';
import bayBowlsClub from './bay-bowls-club.json';
import foreshoreCaravanPark from './foreshore-caravan-park.json';
import coolamonBayMemorialPark from './coolamon-bay-memorial-park.json';
import federationDriveHobbyFarm from './federation-drive-hobby-farm.json';

// JSON imports widen string unions to `string`; the content test checks every
// field against the contract, so the cast is safe.
const ALL = [
  kerbsideBackyard,
  kerbsideFront,
  grevilleaAveWeatherboard,
  ridgeRdQuarterAcre,
  bayRdBeachShack,
  federationDriveStrips,
  gumtreeHeightsFootyOval,
  coolamonBayCricketOval,
  kerbsidePrimarySchoolOval,
  bayBowlsClub,
  foreshoreCaravanPark,
  coolamonBayMemorialPark,
  federationDriveHobbyFarm,
] as unknown as Layout[];

/** Rough career order: backyards first, the big and fiddly jobs later. */
export const LAYOUT_ORDER: string[] = ALL.map((l) => l.key);

export const LAYOUTS: Record<string, Layout> = Object.fromEntries(ALL.map((l) => [l.key, l]));
